var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerticalLines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 201,
    viewBox: "0 0 288 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.3032 0.05896L96.3032 200.059",
    stroke: "url(#paint0_linear_582_3248)",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.043 0.05896L144.043 200.059",
    stroke: "url(#paint1_linear_582_3248)",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.824471 0.05896L0.824462 200.059",
    stroke: "url(#paint2_linear_582_3248)",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.564 0.05896L48.564 200.059",
    stroke: "url(#paint3_linear_582_3248)",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M191.782 0.05896L191.782 200.059",
    stroke: "url(#paint4_linear_582_3248)",
    strokeWidth: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M239.521 0.05896L239.521 200.059",
    stroke: "url(#paint5_linear_582_3248)",
    strokeWidth: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M287.261 0.05896L287.261 200.059",
    stroke: "url(#paint6_linear_582_3248)",
    strokeWidth: 1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_582_3248",
    x1: 0,
    y1: 0,
    x2: -0.00195312,
    y2: 48061.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343440",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0867447,
    stopColor: "#343440",
    stopOpacity: 0.651685
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2141C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901042,
    stopColor: "#DD2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C21",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_582_3248",
    x1: 0,
    y1: 0,
    x2: -0.00195312,
    y2: 48061.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343440",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0867447,
    stopColor: "#343440",
    stopOpacity: 0.651685
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2141C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901042,
    stopColor: "#DD2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C21",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_582_3248",
    x1: 0,
    y1: 0,
    x2: -0.00195312,
    y2: 48061.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343440",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0867447,
    stopColor: "#343440",
    stopOpacity: 0.651685
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2141C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901042,
    stopColor: "#DD2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C21",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_582_3248",
    x1: 0,
    y1: 0,
    x2: -0.00195312,
    y2: 48061.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343440",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0867447,
    stopColor: "#343440",
    stopOpacity: 0.651685
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2141C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901042,
    stopColor: "#DD2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C21",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_582_3248",
    x1: 0,
    y1: 0,
    x2: -0.00195312,
    y2: 48061.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343440",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0867447,
    stopColor: "#343440",
    stopOpacity: 0.651685
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2141C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901042,
    stopColor: "#DD2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C21",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_582_3248",
    x1: 0,
    y1: 0,
    x2: -0.00195312,
    y2: 48061.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343440",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0867447,
    stopColor: "#343440",
    stopOpacity: 0.651685
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2141C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901042,
    stopColor: "#DD2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C21",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_582_3248",
    x1: 0,
    y1: 0,
    x2: -0.00195312,
    y2: 48061.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343440",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0867447,
    stopColor: "#343440",
    stopOpacity: 0.651685
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2141C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901042,
    stopColor: "#DD2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C21",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalLines);
export default __webpack_public_path__ + "static/media/Vertical-lines.70a07b78.svg";
export { ForwardRef as ReactComponent };